module.exports = __webpack_public_path__ + "assets/icon-nft.28a8ab4c.svg";